import React, {useState, FC} from 'react'
import {useHistory, useLocation} from 'react-router';
import styles from './onboarding_talent.module.scss';
import {
    Page,
    Container,
    ButtonContainer,
    ContinueButton
} from "./Onboarding_Talent.styles";
import HeaderStatusBar from "../../../components/HeaderStatusBar";
import RadioButton from 'components/RadioButton/RadioButton';
import {TutorialPopup} from '../TutorialPopup';

// @ts-ignore
const TempStars: any = window.TempStars;

interface OnboardingTalentProps {
        firstName: string
}

const Onboarding_Talent = () => {
    const history = useHistory();
    const { state } = useLocation<OnboardingTalentProps>(); 
    const { firstName } = state;

    const [screenError, setScreenError] = useState(false);
    const [selected, setSelected] = useState<string | null>(null);
    const [isOpenPopup, setIsOpenPopup] = useState(false);
    const [isSkip, setIsSkip] = useState(false);
    
    const OPTIONS = {
        TEMP: "0",
        HIRE: "1"
    }

    const handleClick = (selectedItem: string) => {
        setSelected(selectedItem);
    };

    const onContinue = () => {
        if (selected === OPTIONS.TEMP) {
            setIsOpenPopup(true);
        } else if (selected === OPTIONS.HIRE) {
            TempStars.Analytics.track('Select-Route', {
                route_selected: 'Find-Job'
            });
            return history.push({pathname: 'jobPostsList'});
        }
        else {
            setIsOpenPopup(true);
        }
    }

    const onSkip = () => {
        setIsSkip(true);
        setIsOpenPopup(true);
    }

    const onPopupContinue = () => {
        if (selected === OPTIONS.TEMP && !isSkip) {
            TempStars.Analytics.track('Select-Route', {
                route_selected: 'Find-Temp-Shifts'
            });
        } else {
            TempStars.Analytics.track('Select-Route', {
                route_selected: 'Skip-Calendar'
            });
        }
        setIsOpenPopup(false);
        return TempStars.App.gotoStartingPage();
    }

    return (
        <Page>
            <HeaderStatusBar />
                    <Container>
                        <div className={styles.practiceNameSubtitle}>
                        Welcome, {firstName}...we’re excited you’re joining TempStars!
                        </div>
                        <div className={styles.pageTitle}>
                            What do you want to do first?
                        </div>
                        <div className={styles.pageDescription}>
                            <p>Great temping shifts, or looking for your dream job?  Let’s get your started!</p> 
                        </div>

                        <div className="screenError">
                            {screenError ? 'Please fix the errors below' : undefined}
                        </div>
                    <div className={styles.tempWrapper}>
                        <div className={styles.radioGroup}>
                        <RadioButton 
                                isActive={selected === OPTIONS.TEMP}
                                handleClick={() => handleClick(OPTIONS.TEMP)}
                                item={OPTIONS.TEMP}
                            />
                            <div className={styles.optionTitle}>
                                I want to find temping shifts!
                            </div>
                        </div>
                        <div className={'inset'}>
                            <p className={styles.optionText}>
                                <ul>
                                    <li>Set your own hourly rate</li>
                                    <li>Choose your own schedule</li>
                                    <li>Trusted by over 20,000 dental professionals.</li>
                                </ul>
                            </p>
                        </div>
                    </div>

                    <div className={styles.hireWrapper}>
                        <div className={styles.radioGroup}>
                        <RadioButton 
                                isActive={selected === OPTIONS.HIRE}
                                handleClick={() => handleClick(OPTIONS.HIRE)}
                                item={OPTIONS.HIRE}
                            />
                            <div className={styles.optionTitle}>
                                I'm looking for a great new job
                            </div>
                        </div>
                        <div className={'inset'}>
                            <p className={styles.optionText}>
                                <ul>
                                    <li>Always free to apply</li>
                                    <li>100's of Local Postings</li>
                                    <li>Sort, Filter and Screen offices to help you find the best fit.</li>
                                    <li>TempStars doesn't charge offices for hiring you - so there's no financial barrier to you finding a great place to work</li>
                                </ul>
                            </p>
                        </div>
                    </div>
                    <ButtonContainer>
                    <ContinueButton
                        variant="outlined"
                        size="large"
                        color={"primary"}
                        onClick={onSkip}
                    >
                        Skip for now
                    </ContinueButton> 
                    <ContinueButton
                        variant="contained"
                        size="large"
                        color={"primary"}
                        onClick={onContinue}
                    >
                        Continue
                    </ContinueButton>            
                </ButtonContainer>
                <TutorialPopup
                        isOpen={isOpenPopup}
                        onContinue={onPopupContinue}
                        onClose={() => setIsOpenPopup(false)}
                        title={"Great! Here's an overview"}
                        description={"We're taking you to your home calendar."}
                        listItems={[
                            "Click a green date to see temping shifts available for that day.", 
                            "You can also click 'view all shifts' to see them all.", 
                            "Use filters to find shifts according to your specific preferences.", 
                            "If you're looking for a great job, go to 'Job Board'."
                        ]}
                />
            </Container>
        </Page>
    )
}

export default Onboarding_Talent;